import { ArrayInput, FormDataConsumer, SimpleFormIterator } from "react-admin";
import Inputs from "./Inputs";

export default function CustomerAddressForm() {
  return (
    <ArrayInput
    source="customer_addresses"
      defaultValue={[]}
    >
      <SimpleFormIterator getItemLabel={(index) => `#${index + 1}`}>
        <FormDataConsumer>{Inputs}</FormDataConsumer>
      </SimpleFormIterator>
    </ArrayInput>
  );
}
